import "core-js/modules/es.array.push.js";
import request from "../../util/request";
import { ElLoading } from 'element-plus';
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Statement',
  data() {
    return {
      // search: '',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      small: "small",
      background: "background",
      prev: this.currentPage - 1,
      pager: this.currentPage,
      next: this.currentPage + 1,
      jumper: this.currentPage,
      ticket: [],
      //未分页的数据
      tableData: [],
      //渲染到页面上的数据
      unit: '',
      orderNo: '',
      multipleSelection: [] //存储勾选的数据
    };
  },

  created() {
    // this.load();
  },
  methods: {
    //时间格式
    formatDate(value, fmt) {
      if (value == null || value == '') {
        return "";
      }
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
      }
      return fmt;
    },
    //页面初始化
    load() {
      if (this.unit !== '' || this.orderNo !== '') {
        // console.log("0000")
      } else {
        this.$message({
          message: "请输入查询条件！",
          type: "warning"
        });
        return false;
      }
      let map = {
        unit: this.unit,
        orderNo: this.orderNo
      };
      request.post('/ordrecdevice/getordrecdevices', map).then(res => {
        console.log(res);
        if (res.code === '0') {
          this.ticket = res.data;
          this.total = this.ticket.length;
          this.getPageInfo();
        } else {
          this.$message({
            message: "无数据！",
            type: "error"
          });
        }
      });
    },
    //保持数据
    add() {
      if (this.multipleSelection === [] || this.multipleSelection.length === 0) {
        this.$message({
          message: "至少选择一条数据！",
          type: "warning"
        });
        return false;
      }
      // eslint-disable-next-line no-undef
      const loading = ElLoading.service({
        lock: true,
        text: '执行中...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
        loading.close();
        return 11;
      }, 2000);
      let map = {
        ordRecDeviceList: this.multipleSelection
        // orderNo:this.orderNo,
      };

      request.post('/ordrecdevice/saveState', map).then(res => {
        console.log(res.code + res.mag + res.data + "save" + res);
        clearTimeout(11);
        if (res.code === '0') {
          window.open(res.data); //打开符合性声明地址路径
        } else {
          this.$message({
            message: "生成符合性声明失败！",
            type: "error"
          });
        }
      });
    },
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = [];
      this.multipleSelection = val;
    },
    //分页三件套
    // 获取当前页的数据信息
    getPageInfo() {
      //清空pageTicket中的数据
      this.tableData = [];
      // 获取当前页的数据
      for (let i = (this.currentPage - 1) * this.pageSize; i < this.total; i++) {
        //把遍历的数据添加到pageTicket里面
        this.tableData.push(this.ticket[i]);
        //判断是否达到一页的要求
        if (this.tableData.length === this.pageSize) break;
      }
    },
    handleSizeChange(pageSize) {
      //修改当前每页的数据行数
      this.pageSize = pageSize;
      //数据重新分页
      this.getPageInfo();
    },
    handleCurrentChange(pageNum) {
      //修改当前的页码
      this.currentPage = pageNum;
      //数据重新分页
      this.getPageInfo();
    },
    tableRowClassName({
      rowIndex
    }) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (rowIndex === i) {
          return 'success-row';
        }
      }
      return '';
    }
  }
};